import { Box, Divider, Stack, TableCell, TableRow } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledGrid = styled(Stack)({
  display: "grid",
  gridTemplateColumns: "15px 200px 80px",
  gap: "5px",
  alignItems: "center",
  justifyItems: "start",
});

export const StyledGuideLine = styled(Box)(({ theme }) => ({
  height: "100%", // "calc(100vh - 171.5px)",

  // width: "45px",
  // backgroundColor: theme.palette.hubColors.blueMain,
  // opacity: 0.1,
  // zIndex: 5,

  width: "1.5px",
  backgroundImage: `repeating-linear-gradient(0deg, ${theme.palette.hubColors.blueMain}, ${theme.palette.hubColors.blueMain} 10px, transparent 10px, transparent 20px, ${theme.palette.hubColors.blueMain} 20px), repeating-linear-gradient(90deg, ${theme.palette.hubColors.blueMain}, ${theme.palette.hubColors.blueMain} 10px, transparent 10px, transparent 20px, ${theme.palette.hubColors.blueMain} 20px), repeating-linear-gradient(180deg, ${theme.palette.hubColors.blueMain}, ${theme.palette.hubColors.blueMain} 10px, transparent 10px, transparent 20px, ${theme.palette.hubColors.blueMain} 20px), repeating-linear-gradient(270deg, ${theme.palette.hubColors.blueMain}, ${theme.palette.hubColors.blueMain} 10px, transparent 10px, transparent 20px, ${theme.palette.hubColors.blueMain} 20px)`,
  backgroundSize: "3px 100%, 100% 3px, 3px 100% , 100% 3px",
  backgroundPosition: "0 0, 0 0, 100% 0, 0 100%",
  backgroundRepeat: "no-repeat",
  zIndex: 100,

  position: "absolute",
  top: 0,
  margin: "auto",
  display: "none",
}));
export const StyledTableRow = styled(TableRow, {
  shouldForwardProp: (prop) => !["isDragging"].includes(prop),
})(({ theme, isDragging }) => ({
  borderBottom: "0px !important",
  height: "35px",
  cursor: "default",

  ":hover": {
    ...(!isDragging && {
      "& .TableCell-Customer": {
        backgroundColor: theme.palette.hubColors.greyLightest,
      },
    }),
    "& .TableCell-PastDays": {
      backgroundColor: theme.palette.hubColors.greyLighter,
    },
  },
  ...(isDragging && {
    backgroundColor: theme.palette.hubColors.mainFocusLightest,
    ":hover": {
      backgroundColor: theme.palette.hubColors.mainFocusLightest,
    },
    "& .TableCell-PastDays": {
      backgroundColor: theme.palette.hubColors.mainFocusLighter2,
    },
    "& .GanttBox-Arrows": {
      display: "block",
    },
  }),
}));

export const StyledPinnedColumns = styled(TableCell)(({ theme }) => ({
  position: "sticky",
  left: 0,
  backgroundColor: theme.palette.hubColors.white,
  borderRight: "1px solid",
  borderColor: theme.palette.hubColors.greyLight,
  padding: "5px 12px !important",
  zIndex: 100,
}));

export const StyledDivider = styled(Divider)(({ theme }) => ({
  position: "absolute",
  top: 0,
  right: 0,
  left: 0,
  bottom: 0,
  margin: "auto",
  borderWidth: "1px",
  width: "1px",
  borderColor: theme.palette.hubColors.mainFocus,
  zIndex: 50,
}));

const trisize = 15;
export const StyledTriangle = styled(Box)(({ theme }) => ({
  width: 0,
  height: 0,
  position: "absolute",
  bottom: `0px`,
  left: 0,
  right: 0,
  margin: "auto",
  borderLeft: `${trisize - 7}px solid transparent`,
  borderRight: `${trisize - 7}px solid transparent`,
  borderTop: `${trisize}px solid ${theme.palette.hubColors.mainFocus}`,
}));

export const StyledCell = styled(TableCell, {
  shouldForwardProp: (prop) =>
    !["removePaddingX", "removeBorder", "weekend", "isToday", "past"].includes(
      prop
    ),
})(({ removePaddingX, past, theme, isToday }) => ({
  ...(removePaddingX ? { padding: "0px !important" } : {}),
  ...(past && {
    backgroundColor: theme.palette.hubColors.greyLightest,
  }),
  ...(isToday && {
    boxShadow: `inset -2px 0px 0px ${theme.palette.hubColors.mainFocus}`,
  }),
  maxWidth: "45px",
  width: "45px",
  minWidth: "45px",
  position: "relative",
  overflow: "visible",
  cursor: "default",
}));

const br = "7px";
export const StyledBox = styled(Stack, {
  shouldForwardProp: (prop) =>
    ![
      "start",
      "end",
      "span",
      "backgroundColor",
      "percent",
      "backgroundColor1",
      "backgroundColor2",
    ].includes(prop),
})(
  ({
    start,
    end,
    backgroundColor,
    span,
    theme,
    started,
    percent,
    backgroundColor1,
    backgroundColor2,
  }) => ({
    flexDirection: "row",
    gap: "10px",
    borderRadius: br,
    width: `calc(${span} * 45px)`,
    margin: start ? "0px 0px 0px auto" : end ? "0px auto 0px 0px" : "0px",
    height: "30px",
    padding: "0px",
    boxSizing: "border-box",
    border: "1px solid",
    borderColor: theme.palette.hubColors.greyLight,
    backgroundColor: backgroundColor || theme.palette.hubColors.greyLightest,
    background: `linear-gradient(to right, ${backgroundColor2} ${percent}%, ${backgroundColor1} ${percent}%)`,
    alignItems: "center",
    position: "absolute",
    overflow: "hidden",
    zIndex: 10,
    top: 0,
    bottom: 0,
    right: 0,
    margin: "auto",
    cursor: started ? "not-allowed" : "grab",
    "& .MuiTypography-root": {
      fontSize: 10,
      fontWeight: 600,
      lineHeight: "12px",
      height: "12px",
      userSelect: "none",
    },

    "&:hover": {
      "& .GanttBox-ContextMenu": {
        display: "inline-flex",
      },
    },
  })
);

const BoxWidth = "15px";
export const StyledTagBox = styled(Box, {
  shouldForwardProp: (prop) => !["color"].includes(prop),
})(({ color, theme }) => ({
  width: BoxWidth,
  minWidth: BoxWidth,
  backgroundColor: color,
  height: "100%",
}));
